export default __webpack_public_path__ + "static/media/downlaod.8ce25a7f.jpg";